import React from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ModelListPage } from '/imports/ui/ModelListPage';
import { modelClass, utilityAccountType } from '/imports/api/utilityAccounts';
import { copyToClipboard, formatDateTime } from '/imports/utils';
import { strings } from '/imports/strings';
import { PageHeading } from '/imports/ui/PageHeading';
import { Button } from '/imports/ui/Button';
import { toastOnError } from '/imports/ui/utils';
import { Icon } from '/imports/ui/Icon';
import { useFindOne, useHasUtilityAccounts, useUser } from '/imports/hooks';
import { Orgs } from '/imports/api/orgs';

/** List page for utility accounts with link-copy actions. */
export const UtilityAccountsPage = () => {
  const canReadUtilityAccounts = useHasUtilityAccounts();
  const user = useUser();
  const orgId = user?.orgId;
  const org = useFindOne(() => Orgs.find(orgId));
  const makeUtilityAccountLink = toastOnError(async () => {
    copyToClipboard(`https://${window.location.host}/uail?o=${orgId}&hid=`);
    toast.success(`${strings.CopiedToClipboard()}: ${org.name}`);
  });
  const copyUtilityAccountLink = (_id: string) => {
    copyToClipboard(`${window.location.host}/uai?_id=${_id}`);
    toast.success(strings.CopiedToClipboard());
  };
  return <ModelListPage
    permission={() => canReadUtilityAccounts}
    modelClass={modelClass}
    header={(
      <PageHeading
        left={<h1>{strings.UtilityAccounts()}</h1>}
        right={
          <div className="buttons">
            <Button onClick={() => makeUtilityAccountLink()}>{strings.UtilityLink()}</Button>
          </div>
        }
      />
    )}
    columns={[
      { field: 'name', render: (doc) => <Link to={`${modelClass.pathPrefix}/${doc._id}`}>{doc.username || doc.name}</Link> },
      { field: 'username' }, { field: 'email' },
      { field: 'type', render: (doc) => <span>{utilityAccountType(doc)}</span> },
      { field: 'meters', render: (doc) => <span>{doc._meters?.length || 0}</span> },
      { field: 'expireAt', label: strings.Expires(), render: (doc) => <span>{doc.expiresAt || strings.Never()}</span> },
      { field: 'createdAt', render: (doc) => <span>{doc.createdAt && formatDateTime(doc.createdAt)}</span> },
      { field: 'gbLink', label: strings.Link(), render: (doc) => <Icon className="cursor-pointer" onClick={() => copyUtilityAccountLink(doc._id)} icon="link2" /> },
    ]}
    defaultSort={{ createdAt: -1 }}
  />;
};